<section class="heading-to-auction" id="heading-to-auction" *ngIf="totalCount > 0" [class.is-tint]="tint">
  <div class="wrap">
    <div class="hta-header" [class.has-total]="soldTotal">
     <div class="hta-header-main">
      <span class="hta-eyebrow"><span class="ix" *ngIf="ix">{{ ix }}</span>{{ predicted ? 'Prediction' : 'Held back by DVLA' }}</span>
      <h2 class="hta-title">{{ predicted ? 'Likely held back.' : results ? (heldCount ? 'DVLA auction plates.' : 'Sold at DVLA auction.') : 'Heading to auction.' }}</h2>
      <p class="hta-sub" *ngIf="results && heldCount">
        DVLA kept {{ soldCount + heldCount }} plates from the {{ year }} series back from fixed-price sale for its own auctions.
        {{ soldCount }} have sold so far: the cards show the price paid, fees included. The other {{ heldCount }} are still held for a
        future auction, so register your interest with DVLA. Plates in the sections above carry an <strong>Auction</strong> tag where DVLA holds them.
      </p>
      <p class="hta-sub" *ngIf="results && !heldCount">
        DVLA kept {{ (soldTotal?.count || totalCount).toLocaleString('en-GB') }} plates from the {{ year }} series back from fixed-price sale and sold them at its own auctions.
        These are the prices paid, fees included{{ soldTotal && soldTotal.count > namesAuction.length ? ', top lots first' : '' }}. Plates in the sections above that went to auction show their result on the card.
      </p>
      <p class="hta-sub" *ngIf="data.confirmed">
        DVLA is holding these plates back from the fixed-price sale for a future auction. Plates in the sections above carry an
        <strong>Auction</strong> tag where DVLA holds them. Register your interest with DVLA. {{ data.evidence }}
      </p>
      <p class="hta-sub" *ngIf="!predicted && !results && !data.confirmed">
        DVLA has held back {{ totalCount }} plates from fixed-price sale for future auction. Register your interest with DVLA.
      </p>
      <p class="hta-sub" *ngIf="predicted">
        DVLA holds back its most valuable combinations for auction instead of selling them at a fixed price. Plates we expect
        it to hold carry a <strong>Likely auction</strong> tag in the sections above. These are the rest: readings DVLA
        has held back before that don&rsquo;t fit those sections. {{ data.evidence }}
      </p>
     </div>
     <div class="hta-total" *ngIf="soldTotal as t">
       <span class="hta-total-label">Total sold</span>
       <span class="hta-total-value">&pound;{{ t.pounds.toLocaleString('en-GB') }}</span>
       <span class="hta-total-note">{{ t.count.toLocaleString('en-GB') }} plates{{ t.since ? ' since ' + monthOf(t.since) : '' }}</span>
     </div>
    </div>

    <!-- Sub-section 1: marquee picks — LLM-scored editorial picks.
         First card gets the marquee framing; rest plain. -->
    <div class="hta-subsection" *ngIf="marqueePicks.length > 0">
      <div class="hta-subheader">
        <h3 class="hta-subtitle">{{ predicted ? 'Words to watch' : 'DVLA&rsquo;s marquee picks' }}</h3>
        <span class="hta-subcount">{{ marqueePicks.length }} {{ marqueePicks.length === 1 ? 'plate' : 'plates' }}</span>
      </div>
      <div class="hta-grid hta-grid--marquee">
        <div class="hta-card" *ngFor="let entry of marqueePicks; let i = index">
          <span class="hta-badge">{{ predicted ? 'Auction candidate' : 'Coming to auction' }}</span>
          <a class="hta-link" [routerLink]="platePath(entry)" [attr.aria-label]="entry.word + ', ' + entry.plate">
            <div class="hta-term">{{ entry.word }}</div>
            <div class="hta-plate-wrap">
              <pla-plate [rawPlate]="entry.plate"
                         [showPrice]="false"
                         [customClass]="'flat shaded'"
                         [openModal]="false"
                         [clickThrough]="false"
                         [noMargin]="true"></pla-plate>
            </div>
          </a>
          <p class="hta-editorial">{{ marqueeEditorialFor(entry, i) }}</p>
          <a class="hta-cta" *ngIf="!predicted"
             [href]="dvlaUrl(entry)"
             target="_blank"
             rel="noopener noreferrer">
            Register Interest with DVLA &rarr;
          </a>
        </div>
      </div>
    </div>

    <!-- Sub-section 2: names auction — DVLA-reserved name plates that
         weren't run through phrase scoring. Catalogue, not picks: no
         editorial copy per card. Denser grid; the visual-refinement pass
         will tune the density further. -->
    <div class="hta-subsection" *ngIf="namesAuction.length > 0">
      <div class="hta-subheader">
        <h3 class="hta-subtitle">{{ predicted ? 'Other plates DVLA usually holds back' : results ? (heldCount ? 'Sold and still held' : 'Auction results') : data.confirmed ? 'Other plates heading to auction' : 'Names heading to auction' }}</h3>
        <span class="hta-subcount">{{ namesAuction.length }} {{ namesAuction.length === 1 ? 'plate' : 'plates' }}</span>
      </div>
      <!-- Long lists: best known first, then See more, or jump to a letter. -->
      <ng-container *ngIf="namesAuction.length > pageSize">
        <pla-new-release-az-pills
          [azCounts]="azCounts"
          [activeLetter]="letter"
          (letterClicked)="setLetter($event)">
        </pla-new-release-az-pills>
        <div class="hta-filter-meta" *ngIf="letter">
          Showing plates starting with <strong>{{ letter }}</strong>: {{ filteredCount }}.
          <a role="button" tabindex="0" (click)="setLetter(null)" (keydown.enter)="setLetter(null)">Clear filter</a>
        </div>
      </ng-container>
      <div class="hta-grid hta-grid--cards" *ngIf="asCards">
        <pla-new-release-plate-card
          *ngFor="let card of visibleCards; trackBy: trackByPlate"
          [card]="card"
          [tracked]="isTracked(card)"
          [favourited]="isFavourited(card)"
          (trackClicked)="trackClicked.emit($event)"
          (favouriteClicked)="favouriteClicked.emit($event)">
        </pla-new-release-plate-card>
      </div>
      <div class="hta-grid hta-grid--names" *ngIf="!asCards">
        <div class="hta-name-card" *ngFor="let entry of visibleEntries; trackBy: trackByEntry">
          <a class="hta-link" [routerLink]="platePath(entry)" [attr.aria-label]="entry.word + ', ' + entry.plate">
            <div class="hta-name-term">{{ entry.word }}</div>
            <div class="hta-plate-wrap">
              <pla-plate [rawPlate]="entry.plate"
                         [showPrice]="false"
                         [customClass]="'flat shaded'"
                         [xSmallPlate]="true"
                         [openModal]="false"
                         [clickThrough]="false"
                         [noMargin]="true"></pla-plate>
            </div>
          </a>
          <span class="hta-cta hta-cta--small" *ngIf="results && !isHeld(entry)">{{ resultLabel(entry) }}<span class="hta-date" *ngIf="entry.soldDate && resultLabel(entry) === soldLabel(entry)"><span class="hta-dot"> &middot; </span>{{ monthOf(entry.soldDate) }}</span></span>
          <a class="hta-cta hta-cta--small" *ngIf="!predicted && (!results || isHeld(entry))"
             [href]="dvlaUrl(entry)"
             target="_blank"
             rel="noopener noreferrer">
            Register Interest &rarr;
          </a>
        </div>
      </div>
      <div class="hta-more" *ngIf="!letter && filteredCount > shown">
        <a role="button" tabindex="0" (click)="loadMore()" (keydown.enter)="loadMore()">See {{ nextBatch }} more &rarr;</a>
        <span class="hta-more-count">Showing {{ shown }} of {{ filteredCount }}</span>
      </div>
    </div>
  </div>
</section>
